import { createSelector } from 'reselect';
import { get as _get, merge as _merge } from 'lodash';

import {
    selectFirestore,
    selectIdFromProps,
    selectListPendingFactory,
    selectDetailPendingFactory,
    selectItemPendingFactory,
} from 'services/selectors';

import config from 'config/index';

import { defaultValues } from './config';

const selectPinsState = state => state.pins;

export const selectNewPin = createSelector(selectPinsState, ({ newPin }) => newPin);

export const selectPending = createSelector(selectPinsState, pins => pins.pending);

export const selectListPending = selectListPendingFactory(selectPending);
export const selectDetailPending = selectDetailPendingFactory(selectPending);
export const selectItemPending = selectItemPendingFactory(selectPending);

export const selectPins = createSelector(selectFirestore, firestore =>
    _get(firestore, 'ordered.pins', []).map(pin => ({
        ..._merge({}, defaultValues, pin),
        lat: pin.location.latitude,
        lng: pin.location.longitude,
    })),
);

export const selectPinForUpdate = createSelector(selectFirestore, selectIdFromProps, (firestore, id) =>
    config.app.languages.reduce(
        (data, lang) => {
            const pin = _merge({}, defaultValues, _get(firestore.data, `pin<${id},${lang}>`));
            data[lang] = {
                title: pin.title,
                subtitle: pin.subtitle,
            };
            if (lang === config.app.defaultLanguage) {
                data.category = pin.category;
                data.color = pin.color;
            }
            return data;
        },
        { id },
    ),
);
